export default "__VITE_PUBLIC_ASSET__bc49c2ee__"